export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';
export const REDIRECT_PATH = '/redirect';
export const UNAUTHORIZED_PATH = '/unauthorized';
export const PLAYER_PATH = '/player';
export const PLAYER_PLENARY_PATH = `${PLAYER_PATH}/plenary`;
export const STUDIO_PATH = '/studio';
export const TRANSLATIONS_PATH = '/translations';

export const LOBBY_PATH = '/lobby';
export const LOBBY_SIGNUP_PATH = `${LOBBY_PATH}/signup`;
export const LOBBY_END_PATH = `${LOBBY_PATH}/plenary-ended`;

export const PLAYER_ACTIVITY_PATH = PLAYER_PATH;
export const PLAYER_ASSIGNMENT_PATH = `${PLAYER_PATH}/assignment`;
export const PLAYER_ASSIGNMENT_PLENARY_PATH = `${PLAYER_PLENARY_PATH}/assignment`;

export const STUDIO_EDIT_PATH = `${STUDIO_PATH}/edit`;
export const STUDIO_PREVIEW_PATH = `${STUDIO_PATH}/preview`;
export const STUDIO_SNAPSHOT_HISTORY_PARTIAL_PATH = '/versions/';

export const STUDIO_COURSE_EDIT_PATH = `${STUDIO_PATH}/courses/edit`;
export const STUDIO_COURSE_PREVIEW_PATH = `${STUDIO_PATH}/courses/preview`;
export const STUDIO_PBL_EDIT_PATH = `${STUDIO_PATH}/pbl/edit`;
export const PBL_PREVIEW_PATH = `${STUDIO_PATH}/pbl/preview`;
export const PLENARY_EDIT_PATH = `${STUDIO_PATH}/plenary/edit`;
export const PLENARY_PREVIEW_PATH = `${STUDIO_PATH}/plenary/preview`;
export const PLENARY_PLAYER_PATH = `${PLAYER_PATH}/plenary`;
export const LEARNING_ACTIVITY_EDIT_PATH = `${STUDIO_PATH}/learning-activity/edit`;
export const LEARNING_ACTIVITY_PREVIEW_PATH = `${STUDIO_PATH}/learning-activity/preview`;
export const LEARNING_ACTIVITY_PLAYER_PATH = `${PLAYER_PATH}/learning-activity`;

export const COURSE_PLAYER_PATH = `${PLAYER_PATH}/courses`;

export const AUTH_MODULE_PATHS = {
  home: STUDIO_PATH,
  login: LOGIN_PATH
};

export const STUDIO_PREVIEW_PATH_REGEX = /^\/studio\/[^/]+\/preview(?:\/|$)/;
